import script from "./vip.vue?vue&type=script&setup=true&lang=js"
export * from "./vip.vue?vue&type=script&setup=true&lang=js"

import "./vip.vue?vue&type=style&index=0&id=0d499c8e&lang=less&scoped=true"

import exportComponent from "/data/jenkins_home/workspace/prod-AI-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d499c8e"]])

export default __exports__